<template>
    <div class="account-page">
        <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-card class="plan-card">
                    <div slot="header" class="clearfix">
                        <span>{{ $t('Account') }}: {{ userName }}</span>
                        <el-button
                            style="float: right; padding: 3px 0"
                            type="text"
                            @click="toHome"
                            >{{ $t('upgradeNow') }}</el-button
                        >
                    </div>
                    <!-- <div class="plan_item">
                        <p class="item_name">{{ $t('Plan') }}</p>
                        <p class="item_content"><strong>Free trial</strong></p>
                    </div> -->
                    <div class="plan_item">
                        <p class="item_name">{{ $t('ExpiryDate') }}</p>
                        <p class="item_content" v-if="expiryDate">
                            {{ $formatDate(expiryDate) }}
                        </p>
                        <p class="item_content" v-else>
                            {{ $t('noData') }}
                        </p>
                    </div>
                </el-card>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-card class="subscriptions-card">
                    <div slot="header" class="clearfix">
                        <span>{{ $t('orderList') }}</span>
                    </div>
                    <div v-show="!isMobile">
                        <el-table
                            :data="orderList"
                            style="width: 100%"
                            v-loading="loadingData"
                        >
                            <el-table-column
                                prop="createTime"
                                :label="$t('date')"
                            >
                                <template slot-scope="scope">
                                    {{
                                        $formatDate(
                                            scope.row.createTime,
                                            $i18n.locale
                                        )
                                    }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="orderSn"
                                :label="$t('orderID')"
                            ></el-table-column>
                            <el-table-column :label="$t('Plan')">
                                <template slot-scope="scope">
                                    {{ scope.row.goodsVo.goodsName }}
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('price')">
                                <template slot-scope="scope">
                                    {{ scope.row.orderAmount }}&nbsp;{{
                                        scope.row.orderAmountCcy
                                    }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="status"
                                :label="$t('orderStatus')"
                            >
                                <template slot-scope="scope">
                                    {{ showStatus(scope.row.status) }}
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('moreInfo')">
                                <template slot-scope="scope">
                                    <span style="color: gray">{{
                                        $formatDate(
                                            scope.row.expiredTime,
                                            $i18n.locale
                                        )
                                    }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('paymentLink')">
                                <template slot-scope="scope">
                                    <a
                                        v-if="scope.row.status == 1 && !scope.row.paymentQrCode"
                                        :href="scope.row.paymentLink"
                                        >{{ $t('continuePayment') }}</a
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination-container">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[20, 50, 100]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="totalCount"
                            ></el-pagination>
                        </div>
                    </div>
                    <div
                        v-show="isMobile"
                        class="card-container"
                        @scroll.passive="handleScroll"
                        ref="scrollContainer"
                    >
                        <el-card
                            v-for="(item, index) in orderList"
                            :key="index"
                            class="card-item"
                        >
                            <div class="card-content">
                                <p class="word-break-all">
                                    <span>{{ $t('date') }}:&nbsp;</span>
                                    {{
                                        $formatDate(
                                            item.createTime,
                                            $i18n.locale
                                        )
                                    }}
                                </p>
                                <p class="word-break-all">
                                    <span>{{ $t('Plan') }}:&nbsp;</span
                                    >{{ item.goodsVo.goodsName }}
                                </p>
                                <p class="word-break-all">
                                    <span>{{ $t('orderID') }}:&nbsp;</span
                                    >{{ item.orderSn }}
                                </p>
                                <p class="word-break-all">
                                    <span>{{ $t('price') }}:&nbsp;</span
                                    >{{ item.orderAmount }}&nbsp;{{
                                        item.orderAmountCcy
                                    }}
                                </p>
                                <p class="word-break-all">
                                    <span>{{ $t('orderStatus') }}:&nbsp;</span
                                    >{{ showStatus(item.status) }}
                                </p>
                                <p class="word-break-all">
                                    <span>{{ $t('paymentLink') }}:&nbsp;</span
                                    ><a
                                        v-if="item.status == 1 && !item.paymentQrCode"
                                        :href="item.paymentLink"
                                        >{{ $t('continuePayment') }}</a
                                    >
                                </p>
                            </div>
                        </el-card>
                        <div class="loading-status">
                            <span v-if="loadingData">{{ $t('loading') }}</span>
                            <span v-if="noMoreData">{{
                                $t('noMoreData')
                            }}</span>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <!-- 支付弹窗 -->
        <qr-code-payment-dialog
            :visible.sync="paymentDialogVisible"
            :plan-name="selectedPlanName"
            :plan-amount="selectedPlanAmount"
            :plan-currency="selectedPlanCurrency"
            :qr-code-image="qrCodeImage"
            :order-sn="orderSn"
            @close="handleDialogClose"
            @completed="handlePaymentCompleted"
        />
    </div>
</template>

<script>
import { getOrderList, getOrderDetail } from '@/api/order'
import { getUserInfo } from '@/api/user'
import { createErrorHandler } from '@/utils/errorHandler'
import QrCodePaymentDialog from '@/components/QrCodePaymentDialog.vue'
export default {
    components: {
        QrCodePaymentDialog
    },
    data() {
        return {
            currentPage: 1,
            pageSize: 20,
            orderList: [],
            totalCount: 0,
            loadingData: false,
            statusList: [
                {
                    name: 'pendingPayment',
                    value: 1
                },
                {
                    name: 'paySuccess',
                    value: 2
                },
                {
                    name: 'paymentFailed',
                    value: 3
                },
                {
                    name: 'revoked',
                    value: 4
                },
                {
                    name: 'refunded',
                    value: 5
                },
                {
                    name: 'orderClosure',
                    value: 6
                }
            ],
            expiryDate: '',
            isMobile: false,
            noMoreData: false,
            paymentDialogVisible: false,
            qrCodeImage: '',
            orderSn: '',
            selectedPlanName: '',
            selectedPlanAmount: '',
            selectedPlanCurrency: ''
        }
    },
    mounted() {
        this.checkMobile()
        window.addEventListener('resize', this.checkMobile)
        this.errorHandler = createErrorHandler(this)
        this.getOrderList()
        this.getUserDetail()
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkMobile)
    },
    computed: {
        userName() {
            return this.$store.state.accountName
        }
    },
    methods: {
        checkMobile() {
            this.isMobile = window.innerWidth < 768
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.getOrderList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getOrderList()
        },
        getOrderList() {
            this.loadingData = true
            getOrderList({
                pageNum: this.currentPage,
                pageSize: this.pageSize
            })
                .then((data) => this.errorHandler.handleResponse(data))
                .then((res) => {
                    if (res.code == 200) {
                        this.orderList = res.data.list
                        this.totalCount = res.data.total
                        if (
                            this.currentPage * this.pageSize >=
                            this.totalCount
                        ) {
                            this.noMoreData = true
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                    this.loadingData = false
                })
                .catch((err) => {
                    console.log(err)
                    this.loadingData = false
                })
        },
        showStatus(status) {
            const statusItem = this.statusList.find(
                (item) => item.value === status
            )
            return statusItem ? this.$t(statusItem.name) : this.$t('unknown')
        },
        // 获取用户详情
        getUserDetail() {
            getUserInfo()
                .then((data) => this.errorHandler.handleResponse(data))
                .then((res) => {
                    if (res.code == 200) {
                        this.expiryDate = res.data.vipEndTime
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        toHome() {
            this.$router.push('/')
        },
        // 打开二维码支付弹窗（先获取最新二维码）
        async openQrCodeDialog(row) {
            this.selectedPlanName = row.goodsVo ? row.goodsVo.goodsName : ''
            this.selectedPlanAmount = row.orderAmount || ''
            this.selectedPlanCurrency = row.orderAmountCcy || ''
            this.orderSn = row.orderSn || ''

            try {
                const res = await getOrderDetail({ orderSn: this.orderSn })
                if (res.code == 200 && res.data.paymentQrCode) {
                    const qrCode = res.data.paymentQrCode
                    this.qrCodeImage = qrCode.startsWith('data:image')
                        ? qrCode
                        : `data:image/png;base64,${qrCode}`
                    this.paymentDialogVisible = true
                } else {
                    this.$message.error(this.$t('getQrCodeFailed'))
                }
            } catch (error) {
                console.error('Failed to get QR code:', error)
                this.$message.error(this.$t('getQrCodeFailed'))
            }
        },
        // 弹窗关闭回调（用户点击X或取消）
        handleDialogClose() {
            this.resetDialogData()
            this.refreshPageData()
        },
        // 支付完成回调
        handlePaymentCompleted() {
            this.resetDialogData()
            this.refreshPageData()
        },
        // 重置弹窗数据
        resetDialogData() {
            this.paymentDialogVisible = false
            this.qrCodeImage = ''
            this.orderSn = ''
            this.selectedPlanName = ''
            this.selectedPlanAmount = ''
            this.selectedPlanCurrency = ''
        },
        // 刷新页面数据
        refreshPageData() {
            this.getOrderList()
            this.getUserDetail()
        },
        handleScroll(event) {
            if (!this.isMobile) return

            const container = event.target
            const { scrollTop, scrollHeight, clientHeight } = container
            const threshold = 50 // 提前50px触发加载

            if (scrollHeight - (scrollTop + clientHeight) < threshold) {
                if (!this.loadingData && !this.noMoreData) {
                    this.currentPage++
                    this.getOrderList()
                }
            }
        }
    }
}
</script>

<style scoped>
.account-page {
    padding: 20px;
}

.plan-card {
    margin-bottom: 20px;
}

.subscriptions-card {
    margin-bottom: 20px;
}
.account-page {
    padding: 20px;
}

.plan-card {
    margin-bottom: 20px;
}

.subscriptions-card {
    margin-bottom: 20px;
}

.pagination-container {
    text-align: center;
    margin-top: 20px;
}

.see-more-orders {
    text-align: center;
    margin-top: 20px;
}
.plan_item {
    margin-bottom: 20px;
}
.item_name {
    margin: 0;
    color: gray;
}
.item_content {
    margin: 10px 0 0 0;
}
</style>